import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/service/api.service';
import { CoreService } from 'src/app/service/core.service';
declare const JsBarcode: any;

@Component({
  selector: 'app-barcode-settings',
  templateUrl: './barcode-settings.component.html',
  styleUrls: ['./barcode-settings.component.css']
})
export class BarcodeSettingsComponent implements OnInit {

  Show: boolean = true;

  visible: boolean = false

  country_dec: string;
  paperWidth = 41;
  paperHeight = 35;
  paperSize = 3;
  tableRow = 1;
  tableColumn = 1;
  isEncryptVlaueChecked: boolean[] = [];
  stkprdsel: any;

  barcode_loading = false;
  itm_name_loading = false;
  btnLoading = false;
  pageLoadingImg = false;
  ref_loading = false;
  selctedProd: any;
  resDup: any;
  search: any[];
  batchDetails: any;
  mnf_date: any;
  exp_date: any;
  unit_display: any;
  checkBatch: any;
  printError: any;
  commAll = 2;
  prodsel: any;
  barcode: any;
  purchaseItems: any;
  purch_ref: any;
  br_mt: any = 20;
  br_mr: any = 20;
  br_mb: any = 20;
  br_ml: any = 20;
  resultobj: any = {};
  temp_title: any;
  barcodeDet: any;
  temp_id: any;
  editflag: any = false;
  valErrors = <any>{};
  bpt_id: any;
  brcdItems: any;

  salesItems = []

  arrayItems =
    {
      prd_name: null,
      prd_alias: null,
      prd_id: null,
      prd_ean: null,
      batch: null,
      prd_barcode: null,
      prd_qty: null,
      unit: null,
      unit_id: null,
      prd_rate: null,
      prd_purch_rate: null,
      prd_unit_id: null,
      mnf_date: null,
      exp_date: null
    }

  items = [
    { isChecked: true, label: 'Item Name', data: 'Pepsi 1ltr', fontSize: 11, isBold: false, rotate: 0, top: 37, left: 10 },
    { isChecked: true, label: 'Barcode', data: '0123456789122', fontSize: 11, isBold: true, rotate: 0, top: 89, left: 10 },
    { isChecked: false, label: 'Ean', data: '1212', fontSize: 11, isBold: false, rotate: 0, top: 100, left: 14 },
    { isChecked: true, label: 'Sale Rate', data: '1200000', fontSize: 11, isBold: true, rotate: 0, top: 89, left: 103 },
    { isChecked: false, label: 'Purch Rate', data: '1000000', fontSize: 11, isBold: false, rotate: 0, top: 110, left: 100 },
    { isChecked: false, label: 'MNF Date', data: '12-01-2025', fontSize: 11, isBold: false, rotate: 0, top: 120, left: 14 },
    { isChecked: false, label: 'EXP Date', data: '12-04-2025', fontSize: 11, isBold: false, rotate: 0, top: 130, left: 14 },
  ];

  // page_size = [
  //   { id: 0, name: 'Label (1 inch)', width: this.paperWidth, height: this.paperHeight },
  //   { id: 1, name: 'Label (2 inch)', width: this.paperWidth * 2, height: this.paperHeight * 2 },
  //   { id: 2, name: 'Label (3 inch)', width: this.paperWidth * 3, height: this.paperHeight * 3 },
  //   { id: 3, name: 'A4 Size', width: 210, height: 297 }
  // ];

  page_size = [
    { name: 'Label 1 (4cm x 4cm)', width: '4cm' },
    { name: 'Label 2 (8cm x 4cm)', width: '8cm' },
    { name: 'Label 3 (12cm x 4cm)', width: '12cm' },
    { name: 'Label 4 (21cm x 4cm)', width: '21cm' }
  ];

  selected_paper_size = this.page_size[0];

  // paperSizes = [
  //   { id: 1, paper: 'A4 (210 x 297 mm)' },
  //   { id: 2, paper: 'Letter (8.5 x 11 inches)' },
  //   { id: 3, paper: 'Legal (8.5 x 14 inches)' },
  //   { id: 4, paper: 'A3 (297 x 420 mm)' },
  //   { id: 5, paper: 'B5 (176 x 250 mm)' }
  // ];


  constructor(private coreService: CoreService, private apiService: ApiService) { }

  ngOnInit() {
    this.country_dec=this.coreService.setDecimalLength();
    this.generateBarcode(1);

    this.pageLoadingImg = true;
    setTimeout(() => {
      this.pageLoadingImg = false;
      this.listBarcodeDet();
    }, 1000);

    this.apiService.getAllClientSettings().subscribe((res) => {
      if (res['data']) {
        this.checkBatch = res["data"]["Batch Support"]["cs_value"] ? true : false;
      }
    });
  }

  encryptRate(i) {
    if (this.isEncryptVlaueChecked[i]) {
      this.items[i].data = this.coreService.splitToDigit(this.items[i].data);
    } else {
      this.items[i].data = this.coreService.decryptValue(this.items[i].data);

    }
  }

  // selectPaperSize(selectedId) {
  //   const selectedPaper = this.page_size.find(p => p.id === selectedId);
  //   this.paperWidth = selectedPaper.width;
  //   this.paperHeight = selectedPaper.height;

  // }

  toggleBold(i) {
    this.items[i].isBold = !this.items[i].isBold;
    this.generateBarcode(1);
  }

  listBarcodeDet() {
    let searchval = new FormData();
    this.apiService.getBarcodeTemplate(searchval, 1).subscribe((res) => {
      this.barcodeDet = res.data;
      this.bpt_id = this.barcodeDet[0];
    });
  }

  submitBtn() {
    const searchval = {
      bpt_title: this.temp_title,
      br_mt: this.br_mt,
      br_mr: this.br_mr,
      br_mb: this.br_mb,
      br_ml: this.br_ml,
      bpt_style: this.items
    };

    if (this.temp_title == "" || !this.temp_title) {
      this.valErrors.temp_title = { msg: "Template title is required" };
      return false;
    }

    if (this.br_mt == "" || !this.br_mt) {
      this.valErrors.br_mt = { msg: "Field Required" };
      return false;
    }

    if (this.br_mr == "" || !this.br_mr) {
      this.valErrors.br_mr = { msg: "Field Required" };
      return false;
    }

    if (this.br_mb == "" || !this.br_mb) {
      this.valErrors.br_mb = { msg: "Field Required" };
      return false;
    }

    if (this.br_ml == "" || !this.br_ml) {
      this.valErrors.br_ml = { msg: "Field Required" };
      return false;
    }

    this.btnLoading = true;
    this.apiService.addBarcodeTemplate(searchval).subscribe((res) => {

      setTimeout(() => {
        this.btnLoading = false;

        if (!res.data.error) {
          this.coreService.showMessage('Added Successfully');
          $("#closeModal").click();
        } else {
          this.resultobj = res.data.error;
        }
      }, 500);
    });
    this.listBarcodeDet();
  }

  updateBtn() {
    const searchval = {
      bpt_id: this.temp_id,
      bpt_title: this.temp_title,
      br_mt: this.br_mt,
      br_mr: this.br_mr,
      br_mb: this.br_mb,
      br_ml: this.br_ml,
      bpt_style: this.items
    };

    if (this.temp_title == "" || !this.temp_title) {
      this.valErrors.temp_title = { msg: "Template title is required" };
      return false;
    }

    if (this.br_mt == "" || !this.br_mt) {
      this.valErrors.br_mt = { msg: "Field Required" };
      return false;
    }

    if (this.br_mr == "" || !this.br_mr) {
      this.valErrors.br_mr = { msg: "Field Required" };
      return false;
    }

    if (this.br_mb == "" || !this.br_mb) {
      this.valErrors.br_mb = { msg: "Field Required" };
      return false;
    }

    if (this.br_ml == "" || !this.br_ml) {
      this.valErrors.br_ml = { msg: "Field Required" };
      return false;
    }

    this.btnLoading = true;
    this.apiService.updateBarcodeTemplate(searchval).subscribe((res) => {

      setTimeout(() => {
        this.btnLoading = false;

        if (!res.data.error) {
          this.coreService.showMessage('Updated Successfully');
          $("#closeModal").click();
        } else {
          this.resultobj = res.data.error;
        }
      }, 500);
      this.listBarcodeDet();
    });
  }

  newTemp() {
    this.editflag = false;
    this.valErrors = [];
    this.items = [
      { isChecked: true, label: 'Item Name', data: 'Pepsi 1ltr', fontSize: 11, isBold: false, rotate: 0, top: 42, left: 10 },
      { isChecked: true, label: 'Barcode', data: '0123456789122', fontSize: 11, isBold: true, rotate: 0, top: 89, left: 10 },
      { isChecked: false, label: 'Ean', data: '1212', fontSize: 11, isBold: false, rotate: 0, top: 100, left: 14 },
      { isChecked: true, label: 'Sale Rate', data: '1200000', fontSize: 11, isBold: true, rotate: 0, top: 89, left: 103 },
      { isChecked: false, label: 'Purch Rate', data: '1000000', fontSize: 11, isBold: false, rotate: 0, top: 110, left: 100 },
      { isChecked: false, label: 'MNF Date', data: '12-01-2025', fontSize: 11, isBold: false, rotate: 0, top: 120, left: 14 },
      { isChecked: false, label: 'EXP Date', data: '12-04-2025', fontSize: 11, isBold: false, rotate: 0, top: 130, left: 14 },
    ];

    this.temp_title = '';
    this.br_mt = 35;
    this.br_mr = 20;
    this.br_mb = 30;
    this.br_ml = 20;
    this.generateBarcode(1);
  }

  editTemp(data) {
    this.editflag = true;
    this.valErrors = [];
    this.temp_title = data.bpt_title;
    this.items = data.barcode_style.bpt_style;
    this.temp_id = data.bpt_id;
    this.br_mt = data.barcode_style.br_mt;
    this.br_mr = data.barcode_style.br_mr;
    this.br_mb = data.barcode_style.br_mb;
    this.br_ml = data.barcode_style.br_ml;
    this.generateBarcode(1);
  }

  copyTemp(data) {
    this.editflag = false;
    this.valErrors = [];
    this.temp_title = data.bpt_title;
    this.items = data.barcode_style.bpt_style;
    this.temp_id = data.bpt_id;
    this.br_mt = data.barcode_style.br_mt;
    this.br_mr = data.barcode_style.br_mr;
    this.br_mb = data.barcode_style.br_mb;
    this.br_ml = data.barcode_style.br_ml;
    this.generateBarcode(1);
  }

  deleteTemp(data) {
    const confirmed = confirm('Are you sure you want to delete this template?');
    if (!confirmed) return;

    const searchval = {
      bpt_id: data.bpt_id
    };
    this.apiService.deletedBarcodeTemplate(searchval).subscribe((res) => {
      this.listBarcodeDet();
    });
  }


  generateBarcode(i) {

    if (i == 1) {
      JsBarcode('#barcode', this.items[i].data, {
        format: 'CODE128',
        textMargin: 0,
        displayValue: false,
        width: 2,
        height: 60,
        background: "#f0f0f0",
        marginTop: this.br_mt,
        marginRight: this.br_mr,
        marginBottom: this.br_mb,
        marginLeft: this.br_ml
      });

      // const svgRect = document.querySelector('#barcode');
      // svgRect.setAttribute('width', '200');



    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.items.forEach((_, i) => {
        for (let j = 0; j < this.tableRow; j++) {
          this.generateBarcode(i);
        }
      });
    }, 0);
  }

  // barcode search
  searchStkPrdBarcode(search: any) {
    if (!search) {
      $("#br_err").text("Enter Barcode");
      return false;
    } else {
      $("#br_err").text("");
    }

    this.barcode_loading = true;

    let searchval = new FormData();
    searchval.append("barcode", search);
    this.apiService.getStockbyBarcodeSales(searchval).subscribe((res) => {
      if (res.data) {
        $("#br_err").text("");
        this.stkprdsel = res.data;
        this.getStockDetails(res.data.prd_id);
      } else {
        this.barcode_loading = false;
        $("#br_err").text("No product Found");
      }
    });
  }

  // search product
  selectProd(name: string) {

    this.itm_name_loading = true;

    let searchval = new FormData();
    if (this.commAll == 1) {
      searchval.append('alias_search', '1');
    }
    searchval.append("prd_name", name);
    this.apiService.getProdByName(searchval).subscribe((res) => {
      this.search = res['data'];
    });
  }

  selectProdDetail(product: any) {
    this.itm_name_loading = true;
    if (product) {
      this.stkprdsel = product;
      this.getStockDetails(this.stkprdsel.prd_id);
    }
  }

  // purchase ref no
  purchRefsearch(search: any) {
    this.ref_loading = true;
    const searchval = new FormData();
    searchval.append('purch_id', search);
    this.apiService.getPurchaseData(searchval).subscribe((res) => {

      this.purch_ref = '';

      this.purchaseItems = res;

      console.log("this.purchaseItems");
      console.log(this.purchaseItems);
      
      

      // if (this.purchaseItems && this.purchaseItems.items) {

      //   console.log("this.purchaseItems");
      //   console.log(this.purchaseItems);
        
      //   $("#rf_err").text("");

      //   this.purchaseItems.items.forEach((item, index) => {
      //      let temp = JSON.parse(JSON.stringify(this.bpt_id.barcode_style.bpt_style));
      //      if (this.commAll == 1) {
      //     temp.find(x => x.label == "Item Name").data = item.prd_alias;
      //   } else {
      //     temp.find(x => x.label == "Item Name").data = item.prd_name;
      //   }
      //   temp.find(x => x.label == "Barcode").data = item.prd_barcode;
      //   temp.find(x => x.label == "Ean").data = item.prd_ean;
      //   temp.find(x => x.label == "Sale Rate").data = Number(item.prd_rate).toFixed(2) ;
      //   temp.find(x => x.label == "Purch Rate").data = Number(item.purchased_rate).toFixed(2);
      //   temp.find(x => x.label == "MNF Date").data = item.sb_manufacture_date;
      //   temp.find(x => x.label == "EXP Date").data = item.sb_expiry_date;

      //   console.log(temp);
      //   console.log("temp");
        
      //     // let arr = <any>{};
      //     // let arr1 = <any>{};
      //     // arr.sl_no = index + 1;
      //     // arr.prd_name = item.prd_name;
      //     // arr.prd_alias = item.prd_alias;
      //     // arr.prd_ean = item.prd_ean;
      //     // arr.prd_barcode = item.prd_barcode;
      //     // arr.batch_code = item.sb_batch_code;
      //     // arr.mnf_date = item.sb_manufacture_date;
      //     // arr.exp_date = item.sb_expiry_date;
      //     // arr.prd_qty = item.purchased_qty;
      //     // arr.unit_name = item.punit_code;
      //     // arr.prd_rate = item.purchased_rate;

      //     // arr.data=item.prd_name;

      //     // arr1.push(arr);
      //   });
      // } else {
      //   $("#rf_err").text("No Result Found");
      // }

      this.ref_loading = false;


    });
  }

  getStockDetails(prd_id) {
    const searchval = new FormData();
    searchval.append('prd_id', prd_id);
    this.apiService.getsaleProdDetails(searchval).subscribe((res) => {
      this.barcode_loading = false;
      this.itm_name_loading = false;
      this.selctedProd = res.data;

      this.arrayItems =
      {
        prd_name: this.stkprdsel.prd_name,
        prd_alias: this.stkprdsel.prd_alias,
        prd_id: this.stkprdsel.prd_id,
        prd_ean: this.stkprdsel.prd_ean,
        batch: this.selctedProd.batches,
        prd_barcode: this.stkprdsel.prd_barcode,
        prd_qty: 1,
        unit: this.selctedProd.prod_units,
        unit_id: this.selctedProd.prd_base_unit_id,
        prd_rate: this.selctedProd.bs_srate,
        prd_purch_rate: this.selctedProd.bs_prate,
        prd_unit_id: this.stkprdsel.produnit_unit_id,
        mnf_date: this.selctedProd.batches.sb_manufacture_date,
        exp_date: this.selctedProd.batches.sb_expiry_date
      }

    });

  }

  selectBtach() {
    this.mnf_date = this.batchDetails.sb_manufacture_date;
    this.exp_date = this.batchDetails.sb_expiry_date;
  }

  addSaleItem() {
    this.printError = [];

    if (this.arrayItems.prd_qty == "" || (this.arrayItems.prd_qty <= 0 || isNaN(this.arrayItems.prd_qty))) {
      this.printError.push({ 'qtyErr': 'Required' });
      $('#prd_qty').css("border", "1px solid red")
    } else {
      $('#prd_qty').css("border", "1px solid #ccc");
    }

    if (this.arrayItems.unit_id == "" || !this.arrayItems.unit_id) {
      this.printError.push({ 'unitErr': 'Required' });
      $('#unit').css({ "border": "1px solid red", "border-radius": "6px" });
    } else {
      $('#unit').css("border", "0px");
    }

    if (this.checkBatch && this.batchDetails == undefined && this.selctedProd.total_batch > 0) {
      this.printError.push({ 'batchErr': 'Required' });
      $('#batch').css({ "border": "1px solid red", "border-radius": "6px" });
    }
    else {
      $('#batch').css("border", "0px");
    }

    if (this.printError.length <= 0) {

      this.barcode = '';
      this.prodsel = '';
      let unit_name = this.arrayItems.unit.find(x => x.unit_id == this.arrayItems.unit_id).unit_display;

      this.resDup = this.checkSaleItem(this.salesItems, Number(this.arrayItems.prd_id), Number(this.arrayItems.unit_id), (this.batchDetails) ? this.batchDetails.sb_id : '');
      var existingArray = this.findItemSales(this.salesItems, Number(this.arrayItems.prd_id), Number(this.arrayItems.unit_id), (this.batchDetails) ? this.batchDetails.sb_id : '');

      if (this.resDup && existingArray.length > 0) {
        var existQty = this.salesItems.find(x => x.sl_no === existingArray[0].sl_no).prd_qty;
        this.salesItems.find(x => x.sl_no === existingArray[0].sl_no).prd_qty = Number(existQty) + Number(this.arrayItems.prd_qty);
      } else {

        let temp = JSON.parse(JSON.stringify(this.bpt_id.barcode_style.bpt_style));

        if (this.commAll == 1) {
          temp.find(x => x.label == "Item Name").data = this.arrayItems.prd_alias;
        } else {
          temp.find(x => x.label == "Item Name").data = this.arrayItems.prd_name;
        }
        temp.find(x => x.label == "Barcode").data = this.arrayItems.prd_barcode;
        temp.find(x => x.label == "Ean").data = this.arrayItems.prd_ean;
        temp.find(x => x.label == "Sale Rate").data = Number(this.arrayItems.prd_rate).toFixed(2) ;
        temp.find(x => x.label == "Purch Rate").data = Number(this.arrayItems.prd_purch_rate).toFixed(2);
        temp.find(x => x.label == "MNF Date").data = this.mnf_date;
        temp.find(x => x.label == "EXP Date").data = this.exp_date;

        this.salesItems.push({
          'prd_id': this.arrayItems.prd_id,
          'prd_name': this.arrayItems.prd_name,
          'prd_alias': this.arrayItems.prd_alias,
          'prd_barcode': this.arrayItems.prd_barcode,
          'ean': this.arrayItems.prd_ean,
          'unit_id': this.arrayItems.unit_id,
          'unit_name': unit_name,
          'prd_qty': this.arrayItems.prd_qty,
          'prd_rate': this.arrayItems.prd_rate,
          'prd_purch_rate': this.arrayItems.prd_purch_rate,
          'prd_unit_id': this.arrayItems.prd_unit_id,
          'batch_id': (this.batchDetails) ? this.batchDetails.sb_id : '',
          'batch_code': (this.batchDetails) ? this.batchDetails.sb_batch_code : '',
          'mnf_date': this.mnf_date,
          'prfx': this.selctedProd.currency_code,
          'exp_date': this.exp_date,
          'items': temp,
          'brcd_mt': this.bpt_id.barcode_style.br_mt,
          'brcd_mr': this.bpt_id.barcode_style.br_mr,
          'brcd_mb': this.bpt_id.barcode_style.br_mb,
          'brcd_ml': this.bpt_id.barcode_style.br_ml
        })

        console.log("this.salesItems");
        console.log(this.salesItems);
        

      }

      this.arrayItems = {
        prd_name: null,
        prd_alias: null,
        prd_id: null,
        prd_ean: null,
        batch: null,
        prd_barcode: null,
        prd_qty: null,
        unit: null,
        unit_id: null,
        prd_rate: null,
        prd_purch_rate: null,
        prd_unit_id: null,
        mnf_date: null,
        exp_date: null
      }

      this.batchDetails = null;
      this.mnf_date = null;
      this.exp_date = null;
    }
  }

  printbrcd() {
    console.log("this.salesItems");
    console.log(this.salesItems);

    this.salesItems.forEach((element, i) => {
      JsBarcode('#barcode' + i, element.items[1].data, {
        format: 'CODE128',
        textMargin: 0,
        displayValue: false,
        width: 2,
        height: 55,
        marginTop: element.brcd_mt,
        marginRight: element.brcd_mr,
        marginBottom: element.brcd_mb,
        marginLeft: element.brcd_ml
      });
    })

    $('#printButton').click();
  }

  selectedTemp() {
    this.salesItems.forEach((element) => {

      element.items = [];
      let temp = JSON.parse(JSON.stringify(this.bpt_id.barcode_style.bpt_style));

      if (this.commAll == 1) {
        temp.find(x => x.label == "Item Name").data = element.prd_alias;
      } else {
        temp.find(x => x.label == "Item Name").data = element.prd_name;
      }
      temp.find(x => x.label == "Barcode").data = element.prd_barcode;
      temp.find(x => x.label == "Ean").data = element.ean;
      temp.find(x => x.label == "Sale Rate").data = Number(element.prd_rate).toFixed(2);
      temp.find(x => x.label == "Purch Rate").data = Number(element.prd_purch_rate).toFixed(2);
      temp.find(x => x.label == "MNF Date").data = element.mnf_date;
      temp.find(x => x.label == "EXP Date").data = element.exp_date;
      element.items = temp;
    })


  }

  onTemplateChange(newTemplate) {
    this.bpt_id = newTemplate;
    this.selectedTemp();
  }

  checkSaleItem(myArray, prdid, unit_id, batch_id = '') {
    const { length } = myArray;
    const id = length + 1;
    const found = myArray.some(el => el.prd_id === prdid);
    const unitid = myArray.some(el => el.unit_id === unit_id);
    const batch = myArray.some(el => el.batch_id === batch_id);

    if (found && unitid && batch)
      return (found);
  }

  findItemSales(myArray, prdid, unit_id, batch_id = '') {
    var existArray = myArray.filter((x => x.prd_id === prdid && x.unit_id === unit_id && x.batch_id === batch_id));
    return (existArray);
  }

  // delete items
  deleteSalesItem(i) {
    this.salesItems.splice(i, 1);
  }

  // clear all items
  clearAll() {
    const clearAll = confirm('Are you sure you want to clear all data?');

    if (clearAll) {
      this.salesItems = [];
    }
  }

  // Reset form details when closing the modal
  closeModal() {
    this.salesItems = [];
  }
}
